/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserPreferencesPatchV3 } from '../../models/user-preferences-patch-v-3';
import { UserPreferencesV3 } from '../../models/user-preferences-v-3';

export interface PatchUserPreferencesV3$Params {
      body: UserPreferencesPatchV3
}

export function patchUserPreferencesV3(http: HttpClient, rootUrl: string, params: PatchUserPreferencesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<UserPreferencesV3>> {
  const rb = new RequestBuilder(rootUrl, patchUserPreferencesV3.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserPreferencesV3>;
    })
  );
}

patchUserPreferencesV3.PATH = '/users/preferences';
